import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import MaterialReactTable from "material-react-table";
import { Spinner, Toast, ToastBody, ToastHeader } from "reactstrap";
import useAxios from "../../sections/useAxios";

const MeetingsListing = () => {
  const { id } = useParams();
  const api = useAxios();
  const navigate = useNavigate();
  const [showToast, setShowToast] = useState(false);
  const [toastMsg, setToastMsg] = useState("");

  const {
    data,
    isLoading: meetingsLoading,
    isError,
    error,
  } = useQuery(
    ["company-meetings", id],
    async () => {
      const res = await api.get(`company/all-company-meetings/${id}`);
      return res.data;
    },
    { cacheTime: 0, enabled: !!id }
  );

  const company = data?.company ?? {};
  const meetings = data?.meetings ?? [];

  useEffect(() => {
    if (isError) {
      setToastMsg(error.message || "Something went wrong");
      setShowToast(true);
      setTimeout(() => setShowToast(false), 4000);
    }
  }, [isError, error]);

  const columns = [
    { accessorKey: "id", header: "ID", size: 50 },
    {
      accessorKey: "name",
      header: "Meeting Slot",
      Cell: ({ row }) => (
        <span
          role="button"
          className="text-primary"
          style={{ cursor: "pointer" }}
          onClick={() =>
            navigate(`/slot/${row.original.id}/meetings`)
          }
        >
          {row.original.name}
        </span>
      ),
    },
    { accessorKey: "start_time", header: "Start Time" },
    { accessorKey: "end_time", header: "End Time" },
    {
      accessorKey: "registration_count",
      header: "Registrations",
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
    },
    {
      accessorKey: "created_at",
      header: "Created At",
      Cell: ({ cell }) => new Date(cell.getValue()).toLocaleDateString(),
    },
    {
      accessorKey: "updated_at",
      header: "Updated At",
      Cell: ({ cell }) => new Date(cell.getValue()).toLocaleDateString(),
    },
  ];

  return (
    <div className="container my-4">

      <div className="card p-3 w-50 mb-3">
        <div className="d-flex align-items-center mb-3">
          <i class="fa-solid fa-building me-2 text-center primary-color" style={{ width: "20px" }}> </i> <h6 className="mb-0">{company?.name}</h6>
        </div>
        <div className="d-flex align-items-center mb-3">
          <i class="fa-solid fa-envelope me-2 text-center primary-color" style={{ width: "20px" }}> </i><h6 className="mb-0">{company?.email}</h6>
        </div>
        <div className="d-flex align-items-center">
          <i class="fa-solid fa-signs-post me-2 text-center primary-color" style={{ width: "20px" }}> </i> <h6 className="mb-0">{company?.location}</h6>
        </div>
      </div>

      <h4 className="primary-color fw-bold">Meetings for Company (ID: {id})</h4>

      {meetingsLoading && (
        <div className="d-flex justify-content-center align-items-center my-4">
          <Spinner color="primary" />
        </div>
      )}

      {showToast && (
        <div
          style={{
            position: "fixed",
            top: 20,
            right: 20,
            zIndex: 1050,
            minWidth: "250px",
          }}
        >
          <Toast isOpen={showToast}>
            <ToastHeader icon="danger">Error</ToastHeader>
            <ToastBody>{toastMsg}</ToastBody>
          </Toast>
        </div>
      )}

      {!meetingsLoading && !isError && (
        <MaterialReactTable
          columns={columns}
          data={meetings}
          muiTablePaperProps={{
            elevation: 10,
          }}
        />
      )}
    </div>
  );
};

export default MeetingsListing;
